import { styled } from '@mui/system';
import COLORS from '../../../../../theme/Colors';
import Button from '@mui/material/Button';
import { boxShadowConfig } from '../../../../../theme/Styles';
import FONTS_FAMILY from '../../../../../theme/FontsFamily';

// Main profile container grid
export const ProfileGrid = styled('div')({
    display: 'grid',
    gridTemplateColumns: '320px 1fr',
    gap: '24px',
    width: '100%',
    boxSizing: 'border-box',
    '@media (max-width: 960px)': {
        gridTemplateColumns: '1fr',
    },
});

export const LeftCol = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
});

export const RightCol = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
});

// Left Card: User Info & Actions
export const UserCard = styled('div')({
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    border: '1px solid rgba(198, 197, 208, 0.3)',
    boxShadow: 'none',
    padding: '28px 24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    boxSizing: 'border-box',
});

export const AvatarContainer = styled('div')({
    position: 'relative',
    width: '110px',
    height: '110px',
    marginBottom: '16px',
});

export const AvatarFrame = styled('div')({
    width: '100%',
    height: '100%',
    borderRadius: '24px',
    border: '3px solid #192873',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F0F3FF',
    boxShadow: '0px 4px 10px rgba(3, 13, 57, 0.1)',
});

export const ProfileImage = styled('img')({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
});

export const CameraOverlay = styled('div')({
    position: 'absolute',
    bottom: '-4px',
    right: '-4px',
    backgroundColor: '#192873',
    color: '#FFFFFF',
    borderRadius: '50%',
    width: '28px',
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px solid #FFFFFF',
    boxShadow: 'none',
    cursor: 'pointer',
    '& svg': {
        fontSize: '14px',
    },
    '&:hover': {
        backgroundColor: '#B7102A',
    },
});

export const UserName = styled('h2')({
    fontFamily: FONTS_FAMILY.bold.title,
    fontSize: '20px',
    fontWeight: '700',
    color: '#192873',
    margin: '0 0 6px 0',
    lineHeight: '26px',
});

export const UserRole = styled('p')({
    fontFamily: FONTS_FAMILY.bold.body,
    fontSize: '11px',
    fontWeight: '700',
    color: '#767680',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    margin: '0 0 24px 0',
});

export const DividerLine = styled('div')({
    width: '100%',
    height: '1px',
    backgroundColor: '#E2E8F0',
    marginBottom: '20px',
});

export const ActionButton = styled('button')(({ variant }) => ({
    width: '100%',
    height: '42px',
    borderRadius: '8px',
    border: 'none',
    fontFamily: FONTS_FAMILY.bold.body,
    fontSize: '13px',
    fontWeight: '700',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    transition: 'all 0.2s ease',
    outline: 'none',
    backgroundColor: variant === 'primary' ? '#192873' : '#E7EEFF',
    color: variant === 'primary' ? '#FFFFFF' : '#192873',
    marginBottom: '10px',
    '&:last-child': {
        marginBottom: 0,
    },
    '& svg': {
        fontSize: '16px',
    },
    '&:hover': {
        transform: 'translateY(-1px)',
        backgroundColor: variant === 'primary' ? '#1A234E' : '#D2E1FF',
        boxShadow: 'none',
    },
}));

// Left Card 2: Account Status
export const StatusCard = styled('div')({
    backgroundColor: '#0A1128',
    borderRadius: '16px',
    padding: '24px',
    color: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    boxShadow: 'none',
    boxSizing: 'border-box',
});

export const StatusTitle = styled('p')({
    fontFamily: FONTS_FAMILY.bold.body,
    fontSize: '11px',
    fontWeight: '700',
    color: '#8E9099',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    margin: 0,
});

export const StatusRow = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontFamily: FONTS_FAMILY.regular.body,
    fontSize: '14px',
});

export const StatusLabel = styled('span')({
    color: '#E2E8F0',
});

export const StatusValue = styled('span')({
    fontFamily: FONTS_FAMILY.bold.body,
    fontWeight: '700',
    color: '#FFFFFF',
});

export const BadgeNumber = styled('span')({
    backgroundColor: '#B7102A',
    color: '#FFFFFF',
    fontWeight: '700',
    fontSize: '12px',
    padding: '2px 8px',
    borderRadius: '4px',
    display: 'inline-block',
});

// Right Column: Personal & Institutional Data Cards
export const DataCard = styled('div')({
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    border: '1px solid rgba(198, 197, 208, 0.3)',
    boxShadow: 'none',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
});

export const CardHeaderBar = styled('div')(({ bgType }) => ({
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: bgType === 'navy' ? '#192873' : '#F0F3FF',
    borderBottom: '1px solid #E2E8F0',
    color: bgType === 'navy' ? '#FFFFFF' : '#192873',
}));

export const HeaderTitleWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    '& svg': {
        fontSize: '20px',
    },
});

export const CardHeaderTitle = styled('h3')({
    fontFamily: FONTS_FAMILY.bold.title,
    fontSize: '16px',
    fontWeight: '700',
    margin: 0,
});

export const VerifiedBadge = styled('div')({
    backgroundColor: '#E6F9F0',
    color: '#0E9F6E',
    fontSize: '10px',
    fontWeight: '700',
    letterSpacing: '0.05em',
    padding: '4px 10px',
    borderRadius: '100px',
    textTransform: 'uppercase',
});

export const DataBody = styled('div')({
    padding: '24px 32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    boxSizing: 'border-box',
    '@media (max-width: 600px)': {
        padding: '20px',
    },
});

export const DataGrid = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '24px',
    '@media (max-width: 600px)': {
        gridTemplateColumns: '1fr',
        gap: '16px',
    },
});

export const DataField = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
});

export const FieldLabel = styled('span')({
    fontFamily: FONTS_FAMILY.bold.body,
    fontSize: '11px',
    fontWeight: '700',
    color: '#8E9099',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
});

export const FieldValue = styled('span')({
    fontFamily: FONTS_FAMILY.bold.body,
    fontSize: '14px',
    fontWeight: '600',
    color: '#192873',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    '& svg': {
        color: '#10B981',
        fontSize: '16px',
    },
});

// Company card special components
export const CompanyInfoBox = styled('div')({
    backgroundColor: '#F8F9FD',
    border: '1px solid #E2E8F0',
    borderRadius: '12px',
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    boxSizing: 'border-box',
    '@media (max-width: 600px)': {
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '16px',
    },
});

export const CompanyIconSquare = styled('div')({
    width: '56px',
    height: '56px',
    borderRadius: '10px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E2E8F0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#192873',
    flexShrink: 0,
    boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
    '& svg': {
        fontSize: '28px',
    },
});

export const CompanyTextWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
});

export const RncBadge = styled('span')({
    backgroundColor: '#E7EEFF',
    color: '#192873',
    fontWeight: '700',
    fontSize: '12px',
    padding: '4px 10px',
    borderRadius: '6px',
    display: 'inline-block',
    border: '1px solid #C6D6FF',
    letterSpacing: '0.02em',
});

export const LocationRow = styled('div')({
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    marginTop: '4px',
    '& svg': {
        color: '#767680',
        fontSize: '18px',
        marginTop: '2px',
    },
});

// Bottom quick access cards row
export const QuickAccessGrid = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '20px',
    width: '100%',
    marginTop: '8px',
    '@media (max-width: 768px)': {
        gridTemplateColumns: '1fr',
        gap: '12px',
    },
});

export const QuickAccessCard = styled('div')({
    backgroundColor: '#FFFFFF',
    border: '1px solid rgba(198, 197, 208, 0.3)',
    boxShadow: 'none',
    borderRadius: '12px',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxSizing: 'border-box',
    '& svg': {
        color: '#192873',
        fontSize: '24px',
    },
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: 'none',
        borderColor: '#B7102A',
    },
});

export const QuickTitle = styled('h4')({
    fontFamily: FONTS_FAMILY.bold.body,
    fontSize: '12px',
    fontWeight: '700',
    color: '#192873',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    margin: 0,
});

export const QuickDesc = styled('p')({
    fontFamily: FONTS_FAMILY.regular.body,
    fontSize: '12px',
    color: '#767680',
    margin: 0,
});
